import * as i0 from "@angular/core";
import * as i1 from "ng-uikit-pro-standard";
export class MessageRendererService {
    constructor(toastrService) {
        this.toastrService = toastrService;
    }
    showErrors(mensajes, overrides = null) {
        mensajes.filter(m => m.tipo === "ERROR").forEach(mensaje => {
            if (overrides)
                this.toastrService.error(mensaje.texto, null, overrides);
            else
                this.toastrService.error(mensaje.texto);
        });
    }
    showInfoMessages(mensajes, overrides = null) {
        mensajes.filter(m => m.tipo === "INFO").forEach(mensaje => {
            if (overrides)
                this.toastrService.info(mensaje.texto, null, overrides);
            else
                this.toastrService.info(mensaje.texto);
        });
    }
    showWarningMessages(mensajes, overrides = null) {
        mensajes.filter(m => m.tipo === "WARNING").forEach(mensaje => {
            if (overrides)
                this.toastrService.warning(mensaje.texto, null, overrides);
            else
                this.toastrService.warning(mensaje.texto);
        });
    }
}
MessageRendererService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MessageRendererService_Factory() { return new MessageRendererService(i0.ɵɵinject(i1.ToastService)); }, token: MessageRendererService, providedIn: "root" });
